import angular from 'angular'
import templateUrl from './event-host-list.component.html'
import { EditEventHostModal } from './edit-event-host.component.js';

export const EventHostListComponent = {
    controller: EventHostListController,
    controllerAs: "vm",
    templateUrl
}

function EventHostListController($uibModal, $q, utilityService, eventHostService, retailerService,
    divisionService, stateProvinceService) {
    'ngInject'
    const vm = this;
    vm.$onInit = $onInit;
    vm.loaded = false;
    vm.eventHosts = [];
    vm.retailers = [];
    vm.filters = {};
    vm.onChangePage = onChangePage;
    vm.onChangeFilters = onChangeFilters;
    vm.addNewEventHost = addNewEventHost;
    vm.editEventHost = editEventHost;
    vm.deleteEventHost = deleteEventHost;
    vm.pageNumber = 1;
    vm.pageSize = 50;
    vm.hostTypes = [];

    function $onInit() {
        initializePage();
    }

    function initializePage() {
        utilityService.showLoading();
        vm.hostTypes = eventHostService.getEventHostTypes();
        const divisions = divisionService.retrieveDivisions();

        const loadInitialData = $q.all([stateProvinceService.retrieveStateProvinces(), divisions])
            .then(function ([stateProvinces, divisions]) {
                vm.stateProvinces = stateProvinces;
                vm.divisions = divisions.sort((a, b) => a.Name < b.Name ? -1 : 1);
                return retailerService.retrieveRetailers()
            })
            .then(function (retailers) {
                vm.retailers = retailers
                vm.filters.DivisionID = divisionService.divisionIDs.Rogers;
                vm.filters = loadFilters();
            });

        loadInitialData
            .then(function () {
                vm.loaded = true;
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function loadEventHosts() {
        const param = generateQueryParameter();
        return eventHostService.retrieveEventHostsPage(param.PageIndex, param)
            .then(function (eventHosts) {
                return vm.eventHosts = eventHosts;
            })
    }

    function onChangeFilters() {
        if (vm.loaded) {
            persistFilters();
            vm.filters.PageNumber = vm.pageNumber;
            vm.filters.PageSize = vm.pageSize;
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadEventHosts(), "Changing page failed"));
        }

    }

    function onChangePage() {
        if (vm.loaded) {
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadEventHosts(), "Changing page failed"));
            persistFilters();
        }
    }

    function generateQueryParameter() {
        const params = {
            PageIndex: vm.filters.PageNumber - 1,
            PageSize: vm.filters.PageSize,
            HostType: vm.filters.HostTypeID,
            HostName: vm.filters.HostName,
            HostLocationName: vm.filters.HostLocationName,
            HostNumber: vm.filters.HostNumber,
            RetailerName: vm.filters.RetailerName,
            DivisionID: vm.filters.division ? vm.filters.division.Id : null
        }
        return params;
    }

    function loadFilters() {
        const filtersJson = localStorage.getItem("eventHostListFilters");
        if (filtersJson) {
            const filtersObj = JSON.parse(filtersJson);
            filtersObj.PageNumber = vm.pageNumber;
            filtersObj.PageSize = vm.pageSize;
            return filtersObj;
        }
        // Initialize the filters.
        const filters = {
            PageNumber: vm.pageNumber,
            PageSize: vm.pageSize
        };
        return filters;
    }


    function persistFilters() {
        localStorage.setItem("eventHostListFilters", JSON.stringify({
            HostName: vm.filters.HostName,
            HostLocationName: vm.filters.HostLocationName,
            HostNumber: vm.filters.HostNumber,
            RetailerName: vm.filters.RetailerName,
            HostTypeID: vm.filters.HostTypeID
        }));
    }

    function addNewEventHost() {
        showEditForm();
    }

    function editEventHost(eventHost) {
        showEditForm(eventHost);
    }

    function showEditForm(eventHost) {
        return $uibModal.open({
            ...EditEventHostModal,
            resolve: {
                eventHost: () => eventHost ? angular.copy(eventHost) : createNewEventHostModel(),
                retailers: () => retailerService.retrieveRetailers(),
                stateProvinces: () => vm.stateProvinces,
                hostTypes: () => vm.hostTypes,
                divisionID: () => vm.filters.division ? vm.filters.division.Id : null,
            }
        })
            .result
            .then(function (eventHost) {
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(loadEventHosts(), "Loading page failed"));
            });
    }

    function createNewEventHostModel() {
        return {
            Address: {},
            ContactPhone: {}
        };
    }

    function deleteEventHost(eventHost) {

        utilityService.showLoading();
        eventHostService.deleteEventHost(eventHost.EventHostID)
            .catch(function (ex) {
                alert("Deleting event host failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(loadEventHosts(), "Loading page failed"));
            });
    }

}
